module.exports = __webpack_public_path__ + "img/sankaku_93_red.2c373b32.png";